import { useContext, useEffect, useMemo, useState } from 'react';
import { getCurrentPriceConfig } from '@/api/query/price-config';
import { useMutation } from 'react-query';
import { LanguageContext } from '@/common/contexts/LanguageContext';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import SubscribtionStripeConf from './components/SubscribtionStripeConf';
import SavePayment from '../../../../SavePayment';
import { MobileRibbon, Wrapper } from './OnePageStripeSubscriptionV4.styles';
import Plan from './components/plan/Plan';
import { getCountryFromLang } from '@/common/helpers/getCountryFromLang';
import Timer from './components/timer/Timer';
import Banner from './components/banner/Banner';
import RibbonCZ from './images/cs/cz_gwarancja_mobile.png';
import RibbonSK from './images/sk/sk_gwarancja_mobile.png';
import RibbonHU from './images/hu/hu_gwarancja_mobile.png';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const MOCKUPS_CONFIG = {
	cs: {
		ribbonMobile: RibbonCZ,
	},
	sk: {
		ribbonMobile: RibbonSK,
	},
	hu: {
		ribbonMobile: RibbonHU,
	},
};

const OnePageStripeSubscriptionV4 = () => {
	const translations = useLanguageData('checkout');
	const [email, setEmail] = useState();
	const { lang } = useContext(LanguageContext);
	const [promo, setPromo] = useState();
	const [selectedOption, setSelectedOption] = useState();

	const handleLoadPricesMutation = useMutation({
		mutationFn: (value) => getCurrentPriceConfig(value),
		onSuccess: ({ data }) => {
			const prices = data.prices.sort((a, b) => a.full_price - b.full_price);
			const plan = localStorage.getItem('plan');
			const selected =
				prices?.find((p) => p?.type?.value === plan) || prices[0];

			setSelectedOption(() => selected);
		},
	});

	const options = useMemo(() => {
		if (!selectedOption?.full_price) {
			return null;
		}

		const price = promo
			? selectedOption.promo_full_price
			: selectedOption.full_price;

		return {
			mode: 'subscription',
			amount: Math.floor(price * 100),
			currency: translations.currency,
			locale: ['sv'].includes(lang) ? 'en' : lang,
			appearance: {
				theme: 'flat',
				variables: {
					borderRadius: '10px',
					fontSizeBase: '12px',
				},
				rules: {
					'.Input': {
						borderRadius: '4px',
						padding: '8px',
						fontSize: '14px',
						backgroundColor: '#fff',
						border: '1px solid #D9D9D9',
					},
					'.Tab': {
						padding: '8px',
					},
					'.Label': {
						fontSize: '12px',
						color: '#7F7C85',
					},
				},
			},
		};
	}, [selectedOption]);

	useEffect(() => {
		const payload = {
			country: getCountryFromLang(lang),
		};

		handleLoadPricesMutation.mutate(payload);
	}, []);

	useEffect(() => {
		setTimeout(() => {
			setEmail(() => localStorage.getItem('quiz_email') || '');
			const promo = localStorage.getItem('promo');

			if (promo) {
				setPromo(() => true);
			}
		}, 100);
	}, []);

	return (
		<>
			<Wrapper>
				<Timer promo={promo} />
				<Banner promo={promo} type={selectedOption?.type?.value} lang={lang} />
				<Plan promo={promo} selectedOption={selectedOption} />
				{options && stripePromise && (
					<Elements stripe={stripePromise} options={options}>
						<SubscribtionStripeConf
							selectedProduct={selectedOption}
							promo={promo}
							email={email}
							subscribe={translations?.subscribe}
						/>
					</Elements>
				)}
				<SavePayment />
				<MobileRibbon>
					<img src={MOCKUPS_CONFIG[lang]?.ribbonMobile} />
				</MobileRibbon>
			</Wrapper>
		</>
	);
};

export default OnePageStripeSubscriptionV4;
